import {useState} from 'react';
import {I18n} from '@aws-amplify/core';
import {AiOutlineEdit} from 'react-icons/ai';
import {FlexiButton} from '@flexinet/ui-components';
import {EditFormDrawer} from '../drawers/EditFormDrawer';

// The shared button beside its drawer, never replaced by it.
export const EditButton = () => {
    const [opened, setOpened] = useState(false);

    return (
        <>
            <FlexiButton leftSection={<AiOutlineEdit/>} variant={'filled'} aria-label={I18n.get('Edit')}
                         onClick={() => setOpened(true)}>
                {I18n.get('Edit')}
            </FlexiButton>
            <EditFormDrawer opened={opened} onClose={() => setOpened(false)}/>
        </>
    );
};
